<template>
    <transition name="confirm-fade">
      <ul v-if="isShowConfirm" class="my-confirm">
        <li v-if="!is_open_prize" class="container-no ub ub-ver ub-pc" :class="{ flipped: isFlipped }">
          <div class="close-block ub ub-ae">
              <div class="close ub ub-ac ub-pc" @click.stop="hidden()"></div>
          </div>
          <span class="sp1">恭喜你</span>
          <span class="sp2">获得{{ reward.type }}</span>
          <div class="ub ub-ac">
              <div class="open ub ub-ac ub-pc"><h2 @click="open_prize()">开</h2></div>
          </div>
        </li>
  
        <li v-if="is_open_prize" class="container-yes ub ub-ver  ub-pc">
          <div class="close ub ub-ac ub-pc" @click.stop="hidden()"></div>
          <div class="prize ub ub-ver ub-pc ub-ac">
            <div class="title ub ub-ac ub-pc">
                <span>{{ reward.type }}</span>
            </div>
            <div class="score-block ub ub-ac">
              <span class="sp1">金币+{{ reward.coin }}</span>
            </div>
          </div>
          <div class="red-packet ub ub-pe">
            <div class="more-rewards ub ub-ver">
              <div class="tips ub">
                <span>{{ reward.tips }}</span>
              </div>
              <div class="operate ub ub-ac1">
                <div class="btn ub ub-ac ub-pc" @click="more_reward()">
                  <span>{{ reward.btn_name }}</span>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </transition>
  </template>
  
  <script >
  import { mapMutations, mapActions } from "vuex";
  export default {
    data() {
      return {
        isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
        is_open_prize: false, //是否打开红包
        isFlipped: false, //翻转红包
        reward: {
          "type": "萌新福利",
          "task_type": 11,
          "coin": 200,
          "tips": "明天还可领300金币",
          "path_name":"",
          "btn_name":"收下"
        }
      };
    },
    methods: {
      ...mapMutations(["get", "post"]), //引入方法
      show(reward) {
        this.reward = reward;
        this.isShowConfirm = true;
      },
      hidden() {
        this.isFlipped = false;
        this.is_open_prize = false;
        this.isShowConfirm = false;
      },
      //开
      open_prize() {
          //反转控制
          this.isFlipped = !this.isFlipped;
          var self = this;
          setTimeout(()=>{
              self.is_open_prize = !self.is_open_prize;
          },200);
      },
      more_reward() {
        this.hidden();
        var name = this.reward.path_name;
        if (name !== "") {
          this.$router.push({name: name});
        }
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .my-confirm {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 998;
    /* 防止长按屏幕出现黑色背景色块，以及 iPhone 横屏时字体缩放问题 */
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  
  .confirm-fade-enter-active {
    animation: opacity 0.3s;
  }
  
  .confirm-fade-leave-active {
    animation: outOpacity 0.2s;
  }
  
  @keyframes opacity {
    0% {
      opacity: 0;
    }
  
    100% {
      opacity: 1;
    }
  }
  
  @keyframes outOpacity {
    0% {
      opacity: 1;
    }
  
    100% {
      opacity: 0;
    }
  }
  
  .wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 85%;
    margin: 0 auto;
    z-index: 999;
    user-select: none;
    border-radius: 1rem;
  }
  
  .container-no {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 80%;
    height: 25rem;
    margin: 0 auto;
    z-index: 999;
    user-select: none;
    border-radius: 1rem;
    background-color: #F8424F;
    transition: transform 0.6s;
    transform-style: preserve-3d;
    
    &.flipped {
      transform: translate3d(-50%, -50%, 0) rotateY(180deg);
    }
  
    .close-block {
      width: 100%;
      margin-right: 0.8rem;
      padding: 0.5rem 0;
  
      .close {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 50%;
        background-image: url(../assets/img/new2024/close.png);
        background-size: cover;
        background-position: center;
      }
    }
    .sp1 {
        margin-top: 1rem;
        letter-spacing: 0.2rem;
        font-size: 1.6rem;
        color: #fff;
      }
      .sp2 {
        margin-top: 2.5rem;
        letter-spacing: 0.2rem;
        font-size: 2rem;
        font-weight: bold;
        color: #fff;
      }
      .open {
        margin-top: 4rem;
        width: 6rem;
        height: 6rem;
        background-color: #FEE5B9;
        border-radius: 50%;
        cursor: pointer;
        animation: heartbeat 1.5s ease infinite;
        h2 {
            font-size: 2rem;
            color: #e74708;
        }
      }
      @keyframes heartbeat {
        0% {
          transform: scale(1);
        }
        30% {
          transform: scale(1.1);
        }
        50% {
          transform: scale(1);
        }
        70% {
          transform: scale(1.1);
        }
        100% {
          transform: scale(1);
        }
      }
  }
  
  .container-yes {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 80%;
    height: 25rem;
    margin: 0 auto;
    z-index: 999;
    user-select: none;
    border-radius: 1rem;
    .close {
      position: absolute;
      top: 0.5rem;
      right: 1.5rem;
      width: 1.5rem;
      height: 1.5rem;
      z-index: 11;
      border-radius: 50%;
      background-color: #b3afaf69;
      background-image: url(../assets/img/new2024/close.png);
      background-size: cover;
      background-position: center;
    }
    .prize {
      width: 90%;
      height: 60%;
      background-color: #F6EFE9;
      z-index: 10;
      border-top-left-radius: 1.25rem;
      border-top-right-radius: 1.25rem;
      .title {
        width: 8rem;
        height: 2rem;
        background-color: #F5D8C8;
        border-bottom-left-radius: 1rem;
        border-bottom-right-radius: 1rem;
        span {
            font-size: 1rem;
            font-weight: bold;
            letter-spacing: 0.2rem;
            color: #F67453;
        }
      }
      .score-block {
        flex: 1;
        .sp1 {
            margin-top: 3.5rem;
            font-size: 2rem;
            font-weight: bold;
          }
      }
    }
    .red-packet {
      width: 100%;
      height: 75%;
      margin-top: -60%;
      background-color: #F8424F;
      border-radius: 1.25rem;
      .more-rewards {
        width: 100%;
        background-color: #F8424F;
        border-bottom-left-radius: 1.25rem;
        border-bottom-right-radius: 1.25rem;
        z-index: 11;
        .tips {
          margin-top: 1rem;
          padding: 0 1rem;
          span {
            font-size: 0.9rem;
            color: #fff;
          }
        }
        .operate {
          margin: 1.5rem 0;
          padding: 0 1rem;
          .btn {
              width: 90%;
              height: 3rem;
              border-radius: 2rem;
              background: linear-gradient( 90deg, #F4DFB4, #F8CF90);
              span {
                  font-size: 1rem;
                  font-weight: bold;
                  color: #EB4A14;
              }
            }
        }
      }
    }
  }
  </style>